document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".element-reviews").forEach((el) => {
    const wrapper = el.querySelector(".embed-code-wrapper");

    const observer = new MutationObserver(() => {
      wrapper.classList.add("is-loaded");
    });

    observer.observe(wrapper, { childList: true, subtree: true });
  });
});
